import React, { useEffect, useMemo, useState } from "react";
import { tt } from "@tennis-matches/services/i18n";
import { runAuthCallbackBootstrap } from "../utils/auth-callback-bootstrap.js";

export function AuthCallbackPage({ state }) {
  const t = useMemo(
    () => tt(state?.app?.locale || "de-DE"),
    [state?.app?.locale],
  );
  const read = (key, fallback = "") => {
    const v = typeof t === "function" ? t(key) : key;
    return v && v !== key ? v : fallback;
  };

  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await runAuthCallbackBootstrap({
        isCancelled: () => cancelled,
      });
      if (cancelled || result?.ok) return;
      if (result?.errorKey) {
        setError(read(result.errorKey));
        return;
      }
      if (result?.errorDetail) {
        setError(result.errorDetail);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="card">
      <h2 className="mb0">{read("auth.callback.title")}</h2>
      <p className="muted">{read("auth.callback.subtitle")}</p>
      {error ? (
        <p className="muted">
          {read("auth.callback.error")}: {error}
        </p>
      ) : null}
    </section>
  );
}
